import { EditNote } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useState,useEffect } from 'react'

import { useAlert } from '../../../../../context/AlertContext';
import projectNoteServices from '../projectNoteServices';
import moment from 'moment';

function ProjectNotes({projectId,autoload=false}) {
    const {AppAlert } = useAlert();
    const [note,setNote] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    const [projectNoteList,setProjectNoteList] = useState(null);

    
    const onSubmit = () => {
        let payload = {
            projectId:projectId,
            note:note
        }
        setSavingStatus(true)
        projectNoteServices.save(payload).then(res=>{
            AppAlert(res.msg)
            getProjectNoteList();
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setSavingStatus(false);
            
        })
    }


    const getProjectNoteList = () =>{
        projectNoteServices.getByProjectId(projectId).then(res=>{
            setProjectNoteList(res.data);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    useEffect(()=>{
        if(autoload){
            getProjectNoteList();
        }
    },[])

    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="form-floating mb-3 mt-3">
                        <textarea style={{height:100}} className="form-control" rows="5"  value={note} onChange={(e)=>setNote(e.target.value)}></textarea>
                        <label>Your Note Hare</label>
                    </div>
                </div>
                <div className='col-md-12'>
                    {savingInProgress && <LinearProgress />}
                    {!savingInProgress &&
                        <>
                            {!projectNoteList && <button className='btn btn-outline-primary' onClick={getProjectNoteList} >Get Notes List</button>}
                            <button className='btn btn-primary float-end' onClick={onSubmit}>Save</button>
                        </>
                    }
                </div>
                <div className='col-md-12'>
                    {projectNoteList?.map(projectNote=>
                        <div className='card my-1' key={projectNote.id}>
                            <div className='card-header'>{moment(projectNote.updated_at).fromNow()}</div>
                            <div className='card-body' style={{whiteSpace:"pre-line"}}>{projectNote.note}</div>
                         </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default ProjectNotes